export default "__VITE_ASSET__HS2epKTr__"